import React, { useEffect, useState } from 'react';
import { Star, Heart } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { getProducts } from '@services/productFirebaseService';

function ProductList({ activeCategory, searchTerm }) {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                const data = await getProducts();
                setProducts(data || []);
                setHasError(false);
            } catch (error) {
                setHasError(true);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    const filteredProducts = products.filter((p) => {
        const matchesCategory = activeCategory === 'all' || p.categoryId === activeCategory;
        const matchesSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    if (loading) return <div className="loading-state"><p>Cargando...</p></div>;
    if (hasError) return <div className="error-state"><p>Error al cargar productos.</p></div>;

    return (
        <main className="product-grid">
            {filteredProducts.length > 0 ? (
                filteredProducts.map((p) => (
                    <div
                        className="product-card"
                        key={p.id}
                        onClick={() => navigate(`/detail/`, { state: p })}
                    >
                        <div className="image-container">
                            <span className="favorite-heart">
                                <Heart size={20} color="#E85D5D" fill="#E85D5D" strokeWidth={0} />
                            </span>
                            <img src={p.image} alt={p.name} />
                        </div>
                        <div className="product-info">
                            <h3>{p.name}</h3>
                            <div className="product-meta">
                                <span className="price">
                                    {/* Limpiamos el precio de puntos si vienen en el string */}
                                    $ {Number(String(p.price).replace(/\./g, '')).toLocaleString('es-AR')}
                                </span>
                                <span className="rating">
                                    <Star size={10} color='#FFB84D' fill='#FFB84D' />
                                    {p.rating}
                                </span>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p>No hay resultados.</p>
            )}
        </main>
    );
}

export default ProductList;